export default "__VITE_ASSET__COTpey9r__"